import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormControlLabel,
  Switch,
  styled,
} from "@mui/material";
import React, { cloneElement, useEffect, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Ptag } from "components/core";
import { colors } from "theme";

const GradeAccordion = ({
  children,
  title,
  showSwitch,
  canSelect,
  setToggleStatus,
  expanded,
}) => {
  const [localExpand, setLocalExpand] = useState(false);
  const childWithProps = cloneElement(children, {
    canSelect,
    title,
    showSwitch,
  });
  useEffect(() => {
   setLocalExpand(expanded);
  }, [expanded]);
  const IOSSwitch = styled((props) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor:
            theme.palette.mode === "dark" ? "#2ECA45" : "#65C466",
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color:
          theme.palette.mode === "light"
            ? theme.palette.grey[100]
            : theme.palette.grey[600],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 22,
      height: 22,
    },
    "& .MuiSwitch-track": {
      borderRadius: 13,
      backgroundColor: theme.palette.mode === "light" ? "#FF655A" : "#39393D",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  }));

  return (
    <Accordion
      style={{
        boxShadow: "none",
        border: "none",
      }}
      defaultExpanded={expanded}
      expanded={localExpand}
      onChange={(event, isExpanded) => setLocalExpand(isExpanded)}
    >
      <AccordionSummary
        style={{
          fontSize: "14px",
          padding: "0",
          border: "none",
          boxShadow: "none",
        }}
        expandIcon={
          <ExpandMoreIcon
            color={colors.primaryColor}
            style={{
              transform: !localExpand
                ? "scale(1.8) rotate(270deg)"
                : "scale(1.8) rotate(180deg)",
              transition: "transform 0.3s ease",
            }}
          />
        }
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Ptag
            color={colors.primaryColor}
            fontSize="18px"
            marginTop={localExpand ? "5px" : "32px"}
            marginBottom="16px"
            fontFamily="Montserrat"
          >
            {title}
          </Ptag>
          {showSwitch && (
            <FormControlLabel
              onClick={(e) => e.stopPropagation()}
              control={
                <IOSSwitch
                  sx={{ m: 1 }}
                  checked={canSelect}
                  onChange={(e) => setToggleStatus(e.target.checked)}
                />
              }
            />
          )}
        </div>
      </AccordionSummary>
      <AccordionDetails
        style={{
          padding: "0",
          opacity: canSelect ? 1 : 0.5,
        }}
      >
        {childWithProps}
      </AccordionDetails>
    </Accordion>
  );
};

export default GradeAccordion;
